import lottie from 'lottie-web'
import { useRef, useEffect } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`
const AnimationWrapper = styled.div`
  height: 200px;
  width: 200px;
`

export const LoadingAnimation = () => {
  const element = useRef(null)

  useEffect(() => {
    if (element && element.current)
      lottie.loadAnimation({
        container: element.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: require('../../lottie-files/loading-animation'),
      })
  }, [])

  return (
    <Wrapper>
      <AnimationWrapper>
        <div ref={element} />
      </AnimationWrapper>
    </Wrapper>
  )
}

export default LoadingAnimation
